export interface DemoRequestData {
  name: string;
  email: string;
  phone: string;
  clinic: string;
  message: string;
  timestamp: string;
  id?: number;
}

/**
 * Demo talep formunun POST edileceği tam URL.
 * - Boşsa: geliştirmede Express (server.js) varsayılanı; production’da Netlify Function.
 * - Yerel: önce `npm run server` (port 3002), ardından CRA (`npm start`).
 */
export function getDemoRequestPostUrl(): string {
  const fromEnv = process.env.REACT_APP_DEMO_REQUEST_POST_URL?.trim();
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3002/api/demo-request';
  }
  return '/.netlify/functions/demo-request';
}

export const sendDemoRequestEmail = async (formData: DemoRequestData): Promise<boolean> => {
  const url = getDemoRequestPostUrl();

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      console.warn('Demo talep POST:', response.status, response.statusText, url);
      return false;
    }

    const data = (await response.json().catch(() => ({}))) as { success?: boolean };
    return data.success !== false;
  } catch (error) {
    console.error('Demo talep e-posta/POST hatası:', url, error);
    return false;
  }
};
